const formatItem = function (item) {
	return `
		<li class="popup-cart-item">

			<figure
				class="card-item"
				data-id="${item.id}"
			>

				<a class="card-item-link"
					href="${item.url.includes('?') ? item.url.split('?')[0] : item.url}"
				></a>

				<div class="card-item-thumbnail ratio-card">

					<img
						class="thumb lazyload"
						src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
						width="100%"
						height="auto"
						data-src="${item.image}"
						data-srcset="
							${item.image}&width=320 320w,
							${item.image}&width=480 480w,
							${item.image}&width=640 640w,
							${item.image}&width=960 960w,
							${item.image}&width=1280 1280w,
							${item.image}&width=1600 1600w,
							${item.image}&width=1920 1920w
						"
						data-sizes="auto"
						alt="LEOROSA, item: ${item.product_title} (thumbnail)"
					/>

				</div>

				<div class="card-item-header font-serif-large font-uppercase">

					<h3 class="card-item-header-title font-bold">
						${item.product_title}
					</h3>

					<div class="card-item-header-price">
						${Shopify.formatMoney(item.line_price, '€ {{ amount_no_decimals }}')}
					</div>

				</div>

				<div class="card-item-infos font-serif-large font-uppercase">

					${item.variant_title == null ? `` : `

						<div class="card-item-infos-variant">
							${item.options_with_values[0].name}:
							${item.variant_title.indexOf(`/`) >= 0
								? item.variant_title.split(` / `)[0] + ` (` + item.variant_title.split(` / `)[1] + `)`
								: item.variant_title
							}
						</div>

					`}

					<div class="card-item-infos-quantity">
						Quantity:
						<span class="card-item-infos-quantity-amount">
							${item.quantity}
						</span>
					</div>

				</div>

				<button
					class="card-item-remove cta-inline font-serif-large font-uppercase"
					type="button"
					onclick="removeCartItem(this.closest('.card-item'))"
				>

					<span class="cta-inline-label">
						Remove
					</span>

				</button>

			</figure>

		</li>
	`;
};

const updateCartCounter = function (cart) {
	document.querySelectorAll('[data-cart-count]').forEach(el => {
		el.setAttribute('data-cart-count', cart.item_count);
	});
};

const updateCartItems = function (cart) {

	const wrapper = document.getElementById('popup-cart-items');
	if (!wrapper) return;

	const items = wrapper.querySelectorAll('.card-item');

	const cartItems = new Map();
	cart.items.forEach(item => cartItems.set(item.id, item));

	for (const item of items) {
		const id = Number(item.dataset.id);
		const cartItem = cartItems.get(id);

		if (!cartItem) {
			item.parentNode.remove();
			continue;
		}

		item.querySelector('.card-item-infos-quantity-amount').textContent = cartItem.quantity;
		item.querySelector('.card-item-header-price').textContent =
			Shopify.formatMoney(
				cartItem.line_price, '€ {{ amount_no_decimals }}'
			);

		cartItems.delete(id);
	};

	for (const item of cartItems.values()) {
		wrapper.insertAdjacentHTML('afterbegin', formatItem(item));
	}
};

const updateCartTotal = function (cart) {
	const total = document.getElementById('popup-cart-footer-info-total');
	if (total) {
		total.textContent = Shopify.formatMoney(
			cart.items_subtotal_price, '€ {{ amount_no_decimals }}'
		);
	}
};

let addingItem = false;

async function addCartItem(form) {
	if (addingItem) return;
	addingItem = true;

	// const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

	const cta = form.querySelector('#add-to-cart');
	const label = cta.querySelector('.cta-pill-label-info');

	try {
		const variant =
			form.querySelector('input[name="id"]:checked') ||
			form.querySelector('input[name="id"][type="hidden"]');

		if (!variant) {
			isMobile && cta.classList.add('active');

			if (window.innerWidth < 1081) {
				const top = form.querySelector('.grid-product-form-top');
				const bottom = form.querySelector('.grid-product-form-bottom');

				if (top && bottom) {
					window.scrollTo({
						top: bottom.getBoundingClientRect().top + window.pageYOffset - top.offsetHeight,
						behavior: 'smooth'
					});
				}
			}

			return;
		}

		document.body.classList.add('transition');

		cta.disabled = true;
		label.textContent = 'Adding…';

		if (currentController) {
			currentController.abort();

			await closeNotice();
		}

		const variantId = variant.value;

		let getCart = await fetch('/cart.js');
		let cart = await getCart.json();
		let item = cart.items?.find(item => item.id == variantId);

		const stock = Number(variant.dataset.stockAmount) || 0;
		const policy = variant.dataset.stockPolicy || 'deny';
		const quantity = item ? item.quantity : 0;

		if (policy !== 'continue' && stock > 0 && quantity >= stock) {
			// await delay(500);

			toggleNotice('message', `All ${item ? item.product_title : 'stock'} ${item && !item.product_has_only_default_variant ? item.variant_title + ' ' : ''}already in the cart`);
			cta.disabled = true;
			label.textContent = 'Out of stock';

			return;
		}

		const postItem = await fetch(window.Shopify.routes.root + 'cart/add.js', {
			method: 'POST',
			body: new FormData(form),
		});

		item = await postItem.json();
		if (item.status && item.status !== 200) {
			// await delay(300);

			toggleNotice('message', item.description);
			cta.disabled = true;
			label.textContent = 'Out of stock';

			return;
		}

		getCart = await fetch('/cart.js');
		cart = await getCart.json();

		// await delay(300);

		updateCartCounter(cart);
		updateCartItems(cart);
		updateCartTotal(cart);

		// toggleNotice('success', `${item.product_title} ${!item.product_has_only_default_variant ? item.variant_title + ' ' : ''}added to the cart`);
		toggleNotice('success', 'Added to the cart');
		cta.disabled = false;
		if (form.querySelector('input[name="preorder"').value === "true") {
			label.textContent = 'Pre-order';
		} else {
			label.textContent = 'Add to cart';
		}

	} catch (error) {
		console.error('Error:', error);

		// await delay(300);

		toggleNotice('error', 'Something went wrong');
		cta.disabled = false;
		if (form.querySelector('input[name="preorder"').value === "true") {
			label.textContent = 'Pre-order';
		} else {
			label.textContent = 'Add to cart';
		}

	} finally {
		document.body.classList.remove('transition');

		addingItem = false;
	}
}

async function removeCartItem(item) {
	try {
		document.body.classList.add('transition');

		await fetch(window.Shopify.routes.root + 'cart/update.js', {
			method: 'POST',
			body: `updates[${item.dataset.id}]=0`,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'Accept': 'application/json'
			}
		});

		const getCart = await fetch(window.Shopify.routes.root + 'cart.js');
		const cart = await getCart.json();

		updateCartCounter(cart);
		updateCartItems(cart);
		updateCartTotal(cart);

		if (cart.items.length === 0) {
			await closeCart();
		}
	} catch (error) {
		console.error('Error:', error);

		toggleNotice('error', 'Something went wrong');
	} finally {
		document.body.classList.remove('transition');
	}
}

document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
	form.addEventListener('submit', (e) => {
		e.preventDefault();

		addCartItem(e.currentTarget);
	});
});

document.querySelectorAll('.card-item-remove').forEach(cta => {
	cta.addEventListener('click', () => {
		removeCartItem(
			cta.closest('.card-item')
		);
	});
});
